import { render, staticRenderFns } from "./QuanLyVanBanForm.vue?vue&type=template&id=4edcac89&scoped=true"
import script from "./QuanLyVanBanForm.vue?vue&type=script&lang=js"
export * from "./QuanLyVanBanForm.vue?vue&type=script&lang=js"
import style0 from "./QuanLyVanBanForm.vue?vue&type=style&index=0&id=4edcac89&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edcac89",
  null
  
)

export default component.exports